
    import StepContainer from './common/StepContainer.vue'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'
    import Vue from 'vue'
    import RatingSelector from './common/RatingSelector.vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'
    import HelperMethods from './common/HelperMethods'
    import TipsSelector from './common/TipsSelector.vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import { RatingType } from '../../../../../../Overarching Resources/TS/Survey/types'

    export default Vue.extend({
        //--------
        data () {
            return {                
                ratingQuestionInputRerenderKey: 0
            }
        },
        //--------
        mixins: [RepeatingStepLogic, HelperMethods],
        //--------
        created (): void {   
            //this.currentRating = this.$store.state.survey.surveySetup.ratingType
        },
        //---------
        props: {
            compIndex: Number
        },
        //--------
        components: {
            surveystep: StepContainer,
            ContentDisplayClosed,
            TipsSelector,
            RatingSelector,
            TextAreaButton,
            TextInputButton
        },
        computed: {
            currentRating(): RatingType {
                return this.$store.getters["survey/stepField"]([this.compIndex, 'ratingType']) as RatingType
            },
            ratingQuestionTranslated(): string {

                switch (this.currentRating) {
                    case 'csat':
                        return this.$store.getters['dash/currentLanguagePack'].CSATQuestion
                        break
                    case 'nps':
                        return this.$store.getters['dash/currentLanguagePack'].NPSQuestion
                        break
                    case 'star':
                        return this.$store.getters['dash/currentLanguagePack'].starQuestion
                        break
                }
                return ''
            }
        },
        //--------
        methods: {
            newRating(newR: string): void {

                //this.currentRating = newR
                //removed this.$store.commit('survey/CHANGE_RATING_TYPE', newR)                
                //The ratingType is updated when the survey is pushed to database

                //also update the question to suit the new rating type:
                let newRatingQuestion = ''
                switch (newR) {
                    case 'csat':
                        newRatingQuestion = this.$store.getters['dash/currentLanguagePack'].CSATQuestion
                    break
                    case 'nps':
                        newRatingQuestion =  this.$store.getters['dash/currentLanguagePack'].NPSQuestion
                    break
                    case 'star':
                        newRatingQuestion =  this.$store.getters['dash/currentLanguagePack'].starQuestion
                    break
                }
                
                //update text of question
                this.$store.commit("survey/CHANGE_FIELD", {
                    // @ts-ignore
                    fieldAddress: [this.compIndex, 'content', 'ask'],
                    // @ts-ignore 
                    val: newRatingQuestion.replaceAll('[businessname]', this.$store.state.dash.viewData.business.businessInfo.businessName),
                }); 
                
                //update question data rating type
                this.$store.commit("survey/CHANGE_FIELD", {
                    // @ts-ignore
                    fieldAddress: [this.compIndex, 'ratingType'],
                    // @ts-ignore 
                    val: newR,
                }); 

                //update question data questionID
                this.$store.commit("survey/CHANGE_FIELD", {
                    // @ts-ignore
                    fieldAddress: [this.compIndex, 'questionID'],
                    // @ts-ignore 
                    val: newR === 'nps' ? "NPSr" : (newR === 'star' ? 'STARr' : 'CSATr'),
                });       
                
                //calculate what overarching rating type is (to inform other components)
                this.$store.commit('survey/COMPUTE_RATING_TYPE')

                //have a unique key to force question component to rerender
                this.ratingQuestionInputRerenderKey++

            }
        }
    })
